import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Box from 'components/Box';
import Flex from 'components/Flex';
import Text from 'components/Text';
import { DragHandle, DRAG_HANDLE_HOVER_CLASSNAME } from 'components/SortableStack';
import { CardLink, Image, Subtitle } from '../shared';
function DraggableHorizontalCard(_ref) {
  var dragHandleProps = _ref.dragHandleProps,
    isDragging = _ref.isDragging,
    icon = _ref.icon,
    imageSource = _ref.imageSource,
    index = _ref.index,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    borderRadius: "large",
    overflow: "hidden",
    background: "background",
    textColor: "text",
    minHeight: 70,
    p: "xs",
    pl: 0,
    boxShadow: isDragging ? 'soft' : null,
    className: DRAG_HANDLE_HOVER_CLASSNAME
  }, dragHandleProps), /*#__PURE__*/React.createElement(Box, {
    bold: true,
    width: 35,
    textAlign: "center",
    fontSize: "s"
  }, index), !!icon && /*#__PURE__*/React.createElement(Box, {
    width: 82,
    background: "shaded",
    mr: "s"
  }, /*#__PURE__*/React.createElement(Image, {
    icon: icon,
    iconScale: 1,
    aspectRatio: 2 / 3,
    src: imageSource
  })), /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    pr: "s",
    py: "xxxs",
    position: "relative"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    size: "m",
    lineHeight: 1.4,
    overflow: "wrap"
  }, /*#__PURE__*/React.createElement(CardLink, {
    maxLength: 85
  }, title)), subtitle && /*#__PURE__*/React.createElement(Subtitle, {
    size: "s",
    lineHeight: 1.2,
    mt: "xxxs"
  }, subtitle)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(DragHandle, {
    isDragging: isDragging
  })));
}
export default DraggableHorizontalCard;